import { render } from "./App.vue?vue&type=template&id=fb5c513a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./design/tailwind.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/mediasmartiq/app/smartapp-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__